module.exports = __webpack_public_path__ + "img/team-1.4732b585.jpg";